var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaveyLogotypeYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.8 16.2",
    style: {
      enableBackground: "new 0 0 99.8 16.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFD200;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.4,11.5L34,0l-4.9,0h-3v3.6c0.3,0,0.4,0.1,0.5,0.2c0.2,0.2,0.2,0.4,0.1,0.7l-3.9,7.1c-0.3,0.6-1,1.1-1.6,1.2 v3.5h7v-3.3c-0.5-0.1-0.8-0.7-0.8-0.9c0-0.2,0-0.4,0-0.4c0-0.2,0.1-0.3,0.3-0.3h6.5c0.2,0,0.3,0.1,0.3,0.3c0,0,0.1,0.2,0,0.4 c-0.1,0.4-0.4,0.8-0.8,0.9l0,3.3h8.7v-3.5C41.6,12.7,40.8,12.2,40.4,11.5z M32,8.6l-2.7,0c-0.3,0-0.4-0.2-0.3-0.5l1.3-2.2 c0.2-0.3,0.5-0.3,0.6,0l1.3,2.2C32.5,8.4,32.3,8.6,32,8.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.4,0v3.4c0.5,0.1,0.7,0.2,0.9,0.7c0.2,0.4-0.1,1-0.3,1.3c-0.3,0.5-2.4,4.2-2.6,4.6c-0.1,0.1-0.2,0.1-0.3,0 c-0.2-0.3-2.7-4.9-2.8-5c-0.1-0.2-0.2-0.5-0.1-0.8c0.1-0.2,0.2-0.5,0.6-0.7l0-3.4h-8.7v3.6c0.7,0,1.5,0.5,1.8,1.2l6.4,11.5h4 l6.4-11.5c0.3-0.6,0.9-1.1,1.6-1.2V0H52.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.7,0v3.4c0.2,0.1,0.4,0.2,0.5,0.4c0.1,0.2,0,0.4-0.1,0.5c0,0-1.5,1.6-2.1,2.2l0,0c0,0.1-0.1,0.1-0.1,0.1 c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.1l0,0c-0.4-0.4-1.3-1.5-1.8-2.1c-0.1-0.2-0.3-0.4-0.2-0.6c0.1-0.2,0.4-0.3,0.8-0.4V0h-9.3 v3.6c0.4,0.1,0.8,0.2,1.2,0.4c0.4,0.2,1,0.7,1.5,1.3c1.3,1.5,3.8,4.4,4.2,4.9c0.5,0.6,0.4,1.4,0,2c-0.3,0.4-0.6,0.7-1.3,0.9v3.3h9.1 V13c-0.4,0-1-0.1-1.6-0.7c-0.5-0.5-0.5-1.3-0.3-1.9c0.3-0.6,0.7-1,1.2-1.4c1-1.1,2-2.1,3-3.2c0.4-0.4,0.8-0.8,1.1-1.2 c0.5-0.6,1.1-0.9,1.5-1V0H92.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.1,1.8C17.7,1.5,15.4,0,12.4,0C11.8,0,0,0,0,0s0,3.6,0,3.6c0.7,0,1.2,0.9,1.2,1.6V11c0,0.8-0.5,1.6-1.2,1.6 c0,0,0,0,0,0c0,0,0,3.5,0,3.5h12.4c0,0,6.9,0.3,8.6-5.3C22.7,5.3,18.6,2.2,18.1,1.8z M11.6,12.7H7.3c-0.3,0-0.5-0.2-0.5-0.5V4 C6.8,3.7,7,3.6,7.3,3.6h4.3c0,0,3.7,0.1,3.7,4.6C15.3,12.5,11.6,12.7,11.6,12.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.6,3.6l6,0c0.4,0,0.7,0.1,1,0.3c0.1,0,0.2,0.2,0.2,0.2c0.3,0.3,0.5,0.6,0.5,1c0,0,0,0,0,0h3.9l0-5.1H60.3 v3.6c0.7,0,1.2,0.9,1.2,1.6V11c0,0.8-0.5,1.6-1.2,1.6h0v3.5h18.8v-5.1h-3.9c-0.1,0.9-0.8,1.6-1.7,1.6l-5.9,0c-0.3,0-0.6-0.3-0.6-0.6 c0,0,0-2,0-2c0-0.3,0.3-0.5,0.5-0.5l1.4,0c0.2,0,0.3,0,0.4,0.1c0.4,0.1,0.6,0.4,0.8,0.7h2.8V5.9h-2.8c-0.1,0.3-0.4,0.6-0.8,0.7 c-0.1,0-0.3,0.1-0.4,0.1l-1.4,0c-0.3,0-0.5-0.2-0.6-0.5c0,0,0-2.1,0-2.1C67.1,3.8,67.4,3.6,67.6,3.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaveyLogotypeYellow);
export default __webpack_public_path__ + "static/media/Davey_logotype_Yellow.8be10535541a2a39e3677968be394bcc.svg";
export { ForwardRef as ReactComponent };